import linkedinDark from '../assets/icons/dark/linkedin.svg';
import linkedinLight from '../assets/icons/light/linkedin.svg';
import githubDark from '../assets/icons/dark/github.svg';
import githubLight from '../assets/icons/light/github.svg';
import reactBadge from '../assets/images/React.svg';
import javascriptBadge from '../assets/images/JavaScript.svg';
import htmlBadge from '../assets/images/HTML5.svg';
import cssBadge from '../assets/images/CSS3.svg';

import aroma from '../assets/images/projects/one/Aroma-mockup.png';
import tlt from '../assets/images/projects/two/tlt-mockup.png';
import moogleTasks from '../assets/images/projects/three/MoogleTasks-mockup.png';
import youtelly from '../assets/images/projects/four/youTelly-mockup.png';

export default {
  linkedinDark,
  linkedinLight,
  githubDark,
  githubLight,
  reactBadge,
  javascriptBadge,
  htmlBadge,
  cssBadge,

  aroma,
  tlt,
  moogleTasks,
  youtelly,
};
